export const rawApiData = [
    { "IsDefault": "N", "EId": "95", "Coefficient": 140995, "Id": 98662, "Code": "140995", "Name": "без виду спорту" },
    { "IsDefault": "N", "EId": "63", "Coefficient": 140963, "Id": 97478, "Code": "140963", "Name": "авіамодельний спорт" },
    { "IsDefault": "N", "EId": "215", "Coefficient": 1409215, "Id": 114278, "Code": "1409215", "Name": "автомобільний спорт (крім дрифту, автораллі та участі у перегонах на транспортних засобах)" },
    { "IsDefault": "N", "EId": "100", "Coefficient": 1409100, "Id": 114079, "Code": "1409100", "Name": "автомодельний спорт" },
    { "IsDefault": "N", "EId": "115", "Coefficient": 1409115, "Id": 114101, "Code": "1409115", "Name": "аквабайк" },
    { "IsDefault": "N", "EId": "116", "Coefficient": 1409116, "Id": 114102, "Code": "1409116", "Name": "акробатичний рок-н-рол" },
    { "IsDefault": "N", "EId": "4", "Coefficient": 14094, "Id": 97875, "Code": "14094", "Name": "альпінізм" },
    { "IsDefault": "N", "EId": "132", "Coefficient": 1409132, "Id": 114237, "Code": "1409132", "Name": "американський футбол" },
    { "IsDefault": "N", "EId": "133", "Coefficient": 1409133, "Id": 114232, "Code": "1409133", "Name": "армспорт" },
    { "IsDefault": "N", "EId": "134", "Coefficient": 1409134, "Id": 114189, "Code": "1409134", "Name": "багатоборство тілоохоронців" },
    { "IsDefault": "N", "EId": "6", "Coefficient": 14096, "Id": 97878, "Code": "14096", "Name": "бадмінтон" },
    { "IsDefault": "N", "EId": "96", "Coefficient": 140996, "Id": 98670, "Code": "140996", "Name": "баскетбол" },
    { "IsDefault": "N", "EId": "8", "Coefficient": 14098, "Id": 97880, "Code": "14098", "Name": "бейсбол" },
    { "IsDefault": "N", "EId": "142", "Coefficient": 1409142, "Id": 114219, "Code": "1409142", "Name": "біатлон" },
    { "IsDefault": "N", "EId": "9", "Coefficient": 14099, "Id": 97881, "Code": "14099", "Name": "більярдний спорт" },
    { "IsDefault": "N", "EId": "7", "Coefficient": 14097, "Id": 97882, "Code": "14097", "Name": "бобслей" },
    { "IsDefault": "N", "EId": "135", "Coefficient": 1409135, "Id": 114186, "Code": "1409135", "Name": "богатирське багатоборство" },
    { "IsDefault": "N", "EId": "10", "Coefficient": 140910, "Id": 97883, "Code": "140910", "Name": "бодібілдінг" },
    { "IsDefault": "N", "EId": "136", "Coefficient": 1409136, "Id": 114194, "Code": "1409136", "Name": "бойове самбо" },
    { "IsDefault": "N", "EId": "214", "Coefficient": 1409214, "Id": 114277, "Code": "1409214", "Name": "бокс" },
    { "IsDefault": "N", "EId": "137", "Coefficient": 1409137, "Id": 114214, "Code": "1409137", "Name": "боротьба вільна та греко-римська" },
    { "IsDefault": "N", "EId": "138", "Coefficient": 1409138, "Id": 114244, "Code": "1409138", "Name": "боротьба кураш" },
    { "IsDefault": "N", "EId": "139", "Coefficient": 1409139, "Id": 114236, "Code": "1409139", "Name": "боротьба на поясах" },
    { "IsDefault": "N", "EId": "140", "Coefficient": 1409140, "Id": 114212, "Code": "1409140", "Name": "боротьба на поясах алиш" },
    { "IsDefault": "N", "EId": "141", "Coefficient": 1409141, "Id": 114205, "Code": "1409141", "Name": "боротьба самбо" },
    { "IsDefault": "N", "EId": "11", "Coefficient": 140911, "Id": 97884, "Code": "140911", "Name": "боулінг" },
    { "IsDefault": "N", "EId": "13", "Coefficient": 140913, "Id": 97886, "Code": "140913", "Name": "важка атлетика" },
    { "IsDefault": "N", "EId": "89", "Coefficient": 140989, "Id": 97887, "Code": "140989", "Name": "вейкбординг" },
    { "IsDefault": "N", "EId": "211", "Coefficient": 1409211, "Id": 114274, "Code": "1409211", "Name": "Велосипедний спорт, крім маунтбайку" },
    { "IsDefault": "N", "EId": "143", "Coefficient": 1409143, "Id": 114195, "Code": "1409143", "Name": "вертолітний спорт" },
    { "IsDefault": "N", "EId": "114", "Coefficient": 1409114, "Id": 114091, "Code": "1409114", "Name": "веслувальний слалом" },
    { "IsDefault": "N", "EId": "106", "Coefficient": 1409106, "Id": 114088, "Code": "1409106", "Name": "веслування академічне" },
    { "IsDefault": "N", "EId": "16", "Coefficient": 140916, "Id": 97890, "Code": "140916", "Name": "веслування на байдарках і каное" },
    { "IsDefault": "N", "EId": "118", "Coefficient": 1409118, "Id": 114103, "Code": "1409118", "Name": "веслування на човнах \"дракон\"" },
    { "IsDefault": "N", "EId": "144", "Coefficient": 1409144, "Id": 114230, "Code": "1409144", "Name": "військово-спортивні багатоборства" },
    { "IsDefault": "N", "EId": "17", "Coefficient": 140917, "Id": 97891, "Code": "140917", "Name": "вінсерфінг" },
    { "IsDefault": "N", "EId": "18", "Coefficient": 140918, "Id": 97892, "Code": "140918", "Name": "вітрильний спорт" },
    { "IsDefault": "N", "EId": "19", "Coefficient": 140919, "Id": 97893, "Code": "140919", "Name": "водне поло" },
    { "IsDefault": "N", "EId": "22", "Coefficient": 140922, "Id": 97894, "Code": "140922", "Name": "воднолижний спорт" },
    { "IsDefault": "N", "EId": "119", "Coefficient": 1409119, "Id": 114104, "Code": "1409119", "Name": "водно-моторний спорт" },
    { "IsDefault": "N", "EId": "98", "Coefficient": 140998, "Id": 98668, "Code": "140998", "Name": "волейбол" },
    { "IsDefault": "N", "EId": "107", "Coefficient": 1409107, "Id": 114095, "Code": "1409107", "Name": "волейбол пляжний" },
    { "IsDefault": "N", "EId": "64", "Coefficient": 140964, "Id": 97895, "Code": "140964", "Name": "гандбол" },
    { "IsDefault": "N", "EId": "20", "Coefficient": 140920, "Id": 97896, "Code": "140920", "Name": "гирьовий спорт" },
    { "IsDefault": "N", "EId": "23", "Coefficient": 140923, "Id": 97897, "Code": "140923", "Name": "гімнастика спортивна" },
    { "IsDefault": "N", "EId": "24", "Coefficient": 140924, "Id": 97898, "Code": "140924", "Name": "гімнастика художня" },
    { "IsDefault": "N", "EId": "200", "Coefficient": 1409200, "Id": 114253, "Code": "1409200", "Name": "гірський туризм та трекінг на висоті від 2000 до 4500 метрів" },
    { "IsDefault": "N", "EId": "25", "Coefficient": 140925, "Id": 97901, "Code": "140925", "Name": "гірськолижний спорт" },
    { "IsDefault": "N", "EId": "101", "Coefficient": 1409101, "Id": 114080, "Code": "1409101", "Name": "го" },
    { "IsDefault": "N", "EId": "145", "Coefficient": 1409145, "Id": 114206, "Code": "1409145", "Name": "годзю-рю карате" },
    { "IsDefault": "N", "EId": "109", "Coefficient": 1409109, "Id": 114097, "Code": "1409109", "Name": "гольф" },
    { "IsDefault": "N", "EId": "99", "Coefficient": 140999, "Id": 98669, "Code": "140999", "Name": "городковий спорт" },
    { "IsDefault": "N", "EId": "70", "Coefficient": 140970, "Id": 97904, "Code": "140970", "Name": "дартс" },
    { "IsDefault": "N", "EId": "201", "Coefficient": 1409201, "Id": 114259, "Code": "1409201", "Name": "дельтапланерний спорт" },
    { "IsDefault": "N", "EId": "146", "Coefficient": 1409146, "Id": 114226, "Code": "1409146", "Name": "джиу-джитсу" },
    { "IsDefault": "N", "EId": "110", "Coefficient": 1409110, "Id": 114098, "Code": "1409110", "Name": "дзюдо" },
    { "IsDefault": "N", "EId": "121", "Coefficient": 1409121, "Id": 114105, "Code": "1409121", "Name": "естетична гімнастика" },
    { "IsDefault": "N", "EId": "147", "Coefficient": 1409147, "Id": 114245, "Code": "1409147", "Name": "змішані єдиноборства (mma)" },
    { "IsDefault": "N", "EId": "217", "Coefficient": 1409217, "Id": 114952, "Code": "1409217", "Name": "капоейра" },
    { "IsDefault": "N", "EId": "148", "Coefficient": 1409148, "Id": 114223, "Code": "1409148", "Name": "карате" },
    { "IsDefault": "N", "EId": "149", "Coefficient": 1409149, "Id": 114225, "Code": "1409149", "Name": "карате jka wf" },
    { "IsDefault": "N", "EId": "150", "Coefficient": 1409150, "Id": 114243, "Code": "1409150", "Name": "карате jks" },
    { "IsDefault": "N", "EId": "151", "Coefficient": 1409151, "Id": 114222, "Code": "1409151", "Name": "карате wkc" },
    { "IsDefault": "N", "EId": "156", "Coefficient": 1409156, "Id": 114220, "Code": "1409156", "Name": "кікбоксинг wako" },
    { "IsDefault": "N", "EId": "157", "Coefficient": 1409157, "Id": 114215, "Code": "1409157", "Name": "кікбоксинг wka" },
    { "IsDefault": "N", "EId": "158", "Coefficient": 1409158, "Id": 114187, "Code": "1409158", "Name": "кікбоксинг wpka" },
    { "IsDefault": "N", "EId": "159", "Coefficient": 1409159, "Id": 114196, "Code": "1409159", "Name": "кікбоксинг втка" },
    { "IsDefault": "N", "EId": "30", "Coefficient": 140930, "Id": 97908, "Code": "140930", "Name": "кінний спорт" },
    { "IsDefault": "N", "EId": "160", "Coefficient": 1409160, "Id": 114247, "Code": "1409160", "Name": "кіокушин карате" },
    { "IsDefault": "N", "EId": "161", "Coefficient": 1409161, "Id": 114184, "Code": "1409161", "Name": "кіокушинкай карате" },
    { "IsDefault": "N", "EId": "162", "Coefficient": 1409162, "Id": 114198, "Code": "1409162", "Name": "кіокушинкайкан карате" },
    { "IsDefault": "N", "EId": "31", "Coefficient": 140931, "Id": 97909, "Code": "140931", "Name": "ковзанярський спорт" },
    { "IsDefault": "N", "EId": "152", "Coefficient": 1409152, "Id": 114227, "Code": "1409152", "Name": "козацький двобій" },
    { "IsDefault": "N", "EId": "153", "Coefficient": 1409153, "Id": 114233, "Code": "1409153", "Name": "комбат дзю-дзюцу" },
    { "IsDefault": "N", "EId": "154", "Coefficient": 1409154, "Id": 114238, "Code": "1409154", "Name": "косіки карате" },
    { "IsDefault": "N", "EId": "155", "Coefficient": 1409155, "Id": 114210, "Code": "1409155", "Name": "кунгфу" },
    { "IsDefault": "N", "EId": "33", "Coefficient": 140933, "Id": 97912, "Code": "140933", "Name": "легка атлетика" },
    { "IsDefault": "N", "EId": "163", "Coefficient": 1409163, "Id": 114193, "Code": "1409163", "Name": "лижне двоборство" },
    { "IsDefault": "N", "EId": "164", "Coefficient": 1409164, "Id": 114234, "Code": "1409164", "Name": "лижні гонки" },
    { "IsDefault": "N", "EId": "165", "Coefficient": 1409165, "Id": 114239, "Code": "1409165", "Name": "літаковий спорт (крім авіараллі та повітряних гонок)" },
    { "IsDefault": "N", "EId": "90", "Coefficient": 140990, "Id": 97913, "Code": "140990", "Name": "маунтинбайк" },
    { "IsDefault": "N", "EId": "102", "Coefficient": 1409102, "Id": 114082, "Code": "1409102", "Name": "міні-гольф" },
    { "IsDefault": "N", "EId": "166", "Coefficient": 1409166, "Id": 114185, "Code": "1409166", "Name": "морські багатоборства" },
    { "IsDefault": "N", "EId": "167", "Coefficient": 1409167, "Id": 114228, "Code": "1409167", "Name": "мотоциклетний спорт, крім мотораллі" },
    { "IsDefault": "N", "EId": "34", "Coefficient": 140934, "Id": 97914, "Code": "140934", "Name": "настільний теніс" },
    { "IsDefault": "N", "EId": "168", "Coefficient": 1409168, "Id": 114199, "Code": "1409168", "Name": "панкратіон" },
    { "IsDefault": "N", "EId": "202", "Coefficient": 1409202, "Id": 114258, "Code": "1409202", "Name": "парапланерний спорт" },
    { "IsDefault": "N", "EId": "36", "Coefficient": 140936, "Id": 97917, "Code": "140936", "Name": "пауерліфтінг" },
    { "IsDefault": "N", "EId": "37", "Coefficient": 140937, "Id": 97918, "Code": "140937", "Name": "пейнтбол" },
    { "IsDefault": "N", "EId": "122", "Coefficient": 1409122, "Id": 114106, "Code": "1409122", "Name": "перетягування канату" },
    { "IsDefault": "N", "EId": "103", "Coefficient": 1409103, "Id": 114083, "Code": "1409103", "Name": "петанк" },
    { "IsDefault": "N", "EId": "207", "Coefficient": 1409207, "Id": 114260, "Code": "1409207", "Name": "підводний спорт (в т.ч. дайвінг на глибині до 15 метрів, фрідайвінг)" },
    { "IsDefault": "N", "EId": "40", "Coefficient": 140940, "Id": 97920, "Code": "140940", "Name": "плавання" },
    { "IsDefault": "N", "EId": "203", "Coefficient": 1409203, "Id": 114256, "Code": "1409203", "Name": "планерний спорт" },
    { "IsDefault": "N", "EId": "170", "Coefficient": 1409170, "Id": 114224, "Code": "1409170", "Name": "пляжний гандбол" },
    { "IsDefault": "N", "EId": "171", "Coefficient": 1409171, "Id": 114229, "Code": "1409171", "Name": "пляжний футбол" },
    { "IsDefault": "N", "EId": "123", "Coefficient": 1409123, "Id": 114107, "Code": "1409123", "Name": "повітроплавальний спорт" },
    { "IsDefault": "N", "EId": "42", "Coefficient": 140942, "Id": 97922, "Code": "140942", "Name": "пожежно-прикладний спорт" },
    { "IsDefault": "N", "EId": "94", "Coefficient": 140994, "Id": 97923, "Code": "140994", "Name": "поїздки на джипах, квадроциклах, мотоциклах та іншому транспорті поза дорогами загального користування" },
    { "IsDefault": "N", "EId": "172", "Coefficient": 1409172, "Id": 114197, "Code": "1409172", "Name": "поліатлон" },
    { "IsDefault": "N", "EId": "204", "Coefficient": 1409204, "Id": 114255, "Code": "1409204", "Name": "польоти з використанням безмоторних засобів в т. ч. польоти у якості пілота" },
    { "IsDefault": "N", "EId": "205", "Coefficient": 1409205, "Id": 114261, "Code": "1409205", "Name": "полювання (в т.ч. підводне полювання)" },
    { "IsDefault": "N", "EId": "124", "Coefficient": 1409124, "Id": 114108, "Code": "1409124", "Name": "практична стрільба" },
    { "IsDefault": "N", "EId": "73", "Coefficient": 140973, "Id": 97928, "Code": "140973", "Name": "радіоспорт" },
    { "IsDefault": "N", "EId": "104", "Coefficient": 1409104, "Id": 114084, "Code": "1409104", "Name": "ракетомодельний спорт" },
    { "IsDefault": "N", "EId": "45", "Coefficient": 140945, "Id": 97929, "Code": "140945", "Name": "регбі" },
    { "IsDefault": "N", "EId": "173", "Coefficient": 1409173, "Id": 114118, "Code": "1409173", "Name": "регбіліг" },
    { "IsDefault": "N", "EId": "83", "Coefficient": 140983, "Id": 97930, "Code": "140983", "Name": "риболовля у важкодоступних та віддалених місцевостях" },
    { "IsDefault": "N", "EId": "46", "Coefficient": 140946, "Id": 97931, "Code": "140946", "Name": "Риболовний спорт, крім риболовлі у важкодоступних та віддалених місцевостях" },
    { "IsDefault": "N", "EId": "174", "Coefficient": 1409174, "Id": 114207, "Code": "1409174", "Name": "роликовий спорт" },
    { "IsDefault": "N", "EId": "175", "Coefficient": 1409175, "Id": 114242, "Code": "1409175", "Name": "рукопашний бій" },
    { "IsDefault": "N", "EId": "47", "Coefficient": 140947, "Id": 97933, "Code": "140947", "Name": "санний спорт" },
    { "IsDefault": "N", "EId": "48", "Coefficient": 140948, "Id": 97934, "Code": "140948", "Name": "синхронне плавання" },
    { "IsDefault": "N", "EId": "49", "Coefficient": 140949, "Id": 97935, "Code": "140949", "Name": "сквош" },
    { "IsDefault": "N", "EId": "125", "Coefficient": 1409125, "Id": 114109, "Code": "1409125", "Name": "скелелазіння" },
    { "IsDefault": "N", "EId": "176", "Coefficient": 1409176, "Id": 114240, "Code": "1409176", "Name": "сноубординг" },
    { "IsDefault": "N", "EId": "66", "Coefficient": 140966, "Id": 97937, "Code": "140966", "Name": "софтбол" },
    { "IsDefault": "N", "EId": "78", "Coefficient": 140978, "Id": 97938, "Code": "140978", "Name": "спелеотуризм" },
    { "IsDefault": "N", "EId": "208", "Coefficient": 1409208, "Id": 114262, "Code": "1409208", "Name": "сплав по річкам (в т.ч. рафтинг, каякінг, сплав на катамаранах та ін)" },
    { "IsDefault": "N", "EId": "126", "Coefficient": 1409126, "Id": 114110, "Code": "1409126", "Name": "спорт із собаками" },
    { "IsDefault": "N", "EId": "50", "Coefficient": 140950, "Id": 97940, "Code": "140950", "Name": "спортивна аеробіка" },
    { "IsDefault": "N", "EId": "127", "Coefficient": 1409127, "Id": 114111, "Code": "1409127", "Name": "спортивна акробатика" },
    { "IsDefault": "N", "EId": "51", "Coefficient": 140951, "Id": 97941, "Code": "140951", "Name": "спортивне орієнтування" },
    { "IsDefault": "N", "EId": "74", "Coefficient": 140974, "Id": 97942, "Code": "140974", "Name": "спортивний бридж" },
    { "IsDefault": "N", "EId": "128", "Coefficient": 1409128, "Id": 114116, "Code": "1409128", "Name": "спортивний туризм, крім гірського туризму туризм та трекінгу на висоті від 2000 до 4500 метрів, спелеотуризму" },
    { "IsDefault": "N", "EId": "81", "Coefficient": 140981, "Id": 97944, "Code": "140981", "Name": "спортивні стрибки у воду" },
    { "IsDefault": "N", "EId": "52", "Coefficient": 140952, "Id": 97945, "Code": "140952", "Name": "спортивні танці" },
    { "IsDefault": "N", "EId": "129", "Coefficient": 1409129, "Id": 114113, "Code": "1409129", "Name": "спортінг" },
    { "IsDefault": "N", "EId": "209", "Coefficient": 1409209, "Id": 114257, "Code": "1409209", "Name": "стрибки з висоти в т.ч. парашутний спорт, роупджампінг у воду" },
    { "IsDefault": "N", "EId": "53", "Coefficient": 140953, "Id": 97947, "Code": "140953", "Name": "стрибки на батуті" },
    { "IsDefault": "N", "EId": "177", "Coefficient": 1409177, "Id": 114208, "Code": "1409177", "Name": "стрибки на лижах з трампліна" },
    { "IsDefault": "N", "EId": "111", "Coefficient": 1409111, "Id": 114281, "Code": "1409111", "Name": "стрільба з лука" },
    { "IsDefault": "N", "EId": "112", "Coefficient": 1409112, "Id": 114282, "Code": "1409112", "Name": "стрільба кульова" },
    { "IsDefault": "N", "EId": "113", "Coefficient": 1409113, "Id": 114283, "Code": "1409113", "Name": "стрільба стендова" },
    { "IsDefault": "N", "EId": "178", "Coefficient": 1409178, "Id": 114221, "Code": "1409178", "Name": "стронгмен" },
    { "IsDefault": "N", "EId": "105", "Coefficient": 1409105, "Id": 114085, "Code": "1409105", "Name": "судномодельний спорт" },
    { "IsDefault": "N", "EId": "179", "Coefficient": 1409179, "Id": 114200, "Code": "1409179", "Name": "сумо" },
    { "IsDefault": "N", "EId": "88", "Coefficient": 140988, "Id": 97950, "Code": "140988", "Name": "сучасне п'ятиборство" },
    { "IsDefault": "N", "EId": "180", "Coefficient": 1409180, "Id": 114192, "Code": "1409180", "Name": "таеквондо (ітф)" },
    { "IsDefault": "N", "EId": "181", "Coefficient": 1409181, "Id": 114231, "Code": "1409181", "Name": "таїландський бокс муей тай" },
    { "IsDefault": "N", "EId": "130", "Coefficient": 1409130, "Id": 114114, "Code": "1409130", "Name": "танцювальний спорт" },
    { "IsDefault": "N", "EId": "182", "Coefficient": 1409182, "Id": 114276, "Code": "1409182", "Name": "теніс" },
    { "IsDefault": "N", "EId": "183", "Coefficient": 1409183, "Id": 114190, "Code": "1409183", "Name": "традиційне карате" },
    { "IsDefault": "N", "EId": "57", "Coefficient": 140957, "Id": 97952, "Code": "140957", "Name": "тріатлон" },
    { "IsDefault": "N", "EId": "185", "Coefficient": 1409185, "Id": 114201, "Code": "1409185", "Name": "тхеквондо" },
    { "IsDefault": "N", "EId": "186", "Coefficient": 1409186, "Id": 114216, "Code": "1409186", "Name": "українська боротьба на поясах" },
    { "IsDefault": "N", "EId": "187", "Coefficient": 1409187, "Id": 114209, "Code": "1409187", "Name": "український рукопаш \"спас\"" },
    { "IsDefault": "N", "EId": "188", "Coefficient": 1409188, "Id": 114204, "Code": "1409188", "Name": "універсальний бій" },
    { "IsDefault": "N", "EId": "91", "Coefficient": 140991, "Id": 97953, "Code": "140991", "Name": "участь у перегонах на транспортних засобах або тваринах (в т.ч. авто-мото-авіа-раллі та дрифт, повітряні гонки)" },
    { "IsDefault": "N", "EId": "189", "Coefficient": 1409189, "Id": 114188, "Code": "1409189", "Name": "ушу" },
    { "IsDefault": "N", "EId": "58", "Coefficient": 140958, "Id": 97954, "Code": "140958", "Name": "фехтування" },
    { "IsDefault": "N", "EId": "59", "Coefficient": 140959, "Id": 97955, "Code": "140959", "Name": "фігурне катання на ковзанах" },
    { "IsDefault": "N", "EId": "60", "Coefficient": 140960, "Id": 97956, "Code": "140960", "Name": "фітнес" },
    { "IsDefault": "N", "EId": "190", "Coefficient": 1409190, "Id": 114203, "Code": "1409190", "Name": "флорбол" },
    { "IsDefault": "N", "EId": "191", "Coefficient": 1409191, "Id": 114213, "Code": "1409191", "Name": "французький бокс сават" },
    { "IsDefault": "N", "EId": "192", "Coefficient": 1409192, "Id": 114241, "Code": "1409192", "Name": "фрістайл" },
    { "IsDefault": "N", "EId": "193", "Coefficient": 1409193, "Id": 114235, "Code": "1409193", "Name": "фрі-файт" },
    { "IsDefault": "N", "EId": "194", "Coefficient": 1409194, "Id": 114211, "Code": "1409194", "Name": "фунакоші шотокан карате" },
    { "IsDefault": "N", "EId": "93", "Coefficient": 140993, "Id": 97957, "Code": "140993", "Name": "футбол" },
    { "IsDefault": "N", "EId": "68", "Coefficient": 140968, "Id": 97958, "Code": "140968", "Name": "футзал" },
    { "IsDefault": "N", "EId": "197", "Coefficient": 1409197, "Id": 114218, "Code": "1409197", "Name": "хокей з шайбою" },
    { "IsDefault": "N", "EId": "196", "Coefficient": 1409196, "Id": 114202, "Code": "1409196", "Name": "хокей на траві" },
    { "IsDefault": "N", "EId": "198", "Coefficient": 1409198, "Id": 114191, "Code": "1409198", "Name": "хортинг" },
    { "IsDefault": "N", "EId": "69", "Coefficient": 140969, "Id": 114115, "Code": "140969", "Name": "чирлідинг" },
    { "IsDefault": "N", "EId": "75", "Coefficient": 140975, "Id": 97960, "Code": "140975", "Name": "шахи" },
    { "IsDefault": "N", "EId": "76", "Coefficient": 140976, "Id": 97961, "Code": "140976", "Name": "шашки" },
    { "IsDefault": "N", "EId": "199", "Coefficient": 1409199, "Id": 114217, "Code": "1409199", "Name": "шорт-трек" },
    { "IsDefault": "N", "EId": "218", "Coefficient": 1409218, "Id": 117483, "Code": "1409218", "Name": "S0a" },
    { "IsDefault": "N", "EId": "219", "Coefficient": 1409219, "Id": 117484, "Code": "1409219", "Name": "S0p" },
    { "IsDefault": "N", "EId": "221", "Coefficient": 1409221, "Id": 117481, "Code": "1409221", "Name": "S1a" },
    { "IsDefault": "N", "EId": "220", "Coefficient": 1409220, "Id": 117482, "Code": "1409220", "Name": "S1p" },
    { "IsDefault": "N", "EId": "222", "Coefficient": 1409222, "Id": 117485, "Code": "1409222", "Name": "S2a" },
    { "IsDefault": "N", "EId": "223", "Coefficient": 1409223, "Id": 117486, "Code": "1409223", "Name": "S2p" },
    { "IsDefault": "N", "EId": "224", "Coefficient": 1409224, "Id": 117487, "Code": "1409224", "Name": "SEa" },
    { "IsDefault": "N", "EId": "225", "Coefficient": 1409225, "Id": 117488, "Code": "1409225", "Name": "SEp" }
];

export const sportGroupMap = {
    "140995": "NONE",
    "140963": "S0",
    "1409215": "S2",
    "1409100": "S0",
    "1409115": "S1",
    "1409116": "S1",
    "14094": "SE",
    "1409132": "S2",
    "1409133": "S2",
    "1409134": "S2",
    "14096": "S1",
    "140996": "S1",
    "14098": "S1",
    "1409142": "S2",
    "14099": "S0",
    "14097": "S2",
    "1409135": "S2",
    "140910": "S1",
    "1409136": "S2",
    "1409214": "S2",
    "1409137": "S2",
    "1409138": "S2",
    "1409139": "S2",
    "1409140": "S2",
    "1409141": "S2",
    "140911": "S0",
    "140913": "S2",
    "140989": "S1",
    "1409211": "S1",
    "1409143": "S2",
    "1409114": "S1",
    "1409106": "S1",
    "140916": "S1",
    "1409118": "S1",
    "1409144": "S2",
    "140918": "S1",
    "140919": "S1",
    "140922": "S1",
    "1409119": "S1",
    "140998": "S1",
    "1409107": "S1",
    "140964": "S2",
    "140920": "S1",
    "140923": "S2",
    "140924": "S2",
    "1409200": "SE",
    "140925": "S2",
    "1409101": "S0",
    "1409145": "S2",
    "1409109": "S1",
    "140999": "S0",
    "140970": "S0",
    "1409201": "SE",
    "1409146": "S2",
    "1409110": "S1",
    "1409121": "S1",
    "1409147": "S2",
    "1409217": "S2",
    "1409148": "S2",
    "1409149": "S2",
    "1409150": "S2",
    "1409151": "S2",
    "1409156": "S2",
    "1409157": "S2",
    "1409158": "S2",
    "1409159": "S2",
    "140930": "S2",
    "1409160": "S2",
    "1409161": "S2",
    "1409162": "S2",
    "140931": "S2",
    "1409152": "S2",
    "1409153": "S2",
    "1409154": "S2",
    "1409155": "S2",
    "140933": "S1",
    "1409163": "S2",
    "1409164": "S2",
    "1409165": "S2",
    "140990": "SE",
    "1409102": "S0",
    "1409166": "S2",
    "1409167": "S2",
    "140934": "S0",
    "1409168": "S2",
    "1409202": "SE",
    "140936": "S2",
    "140937": "S1",
    "1409122": "S1",
    "1409103": "S0",
    "1409207": "SE",
    "140940": "S2",
    "1409203": "SE",
    "1409170": "S2",
    "1409171": "S2",
    "1409123": "S1",
    "140942": "S1",
    "140994": "SE",
    "1409172": "S2",
    "1409204": "SE",
    "1409205": "SE",
    "1409124": "S1",
    "140973": "S0",
    "1409104": "S0",
    "140945": "S2",
    "1409173": "S2",
    "140983": "SE",
    "140946": "S0",
    "1409174": "S2",
    "1409175": "S2",
    "140947": "S2",
    "140948": "S2",
    "140949": "S1",
    "1409125": "S1",
    "1409176": "S2",
    "140966": "S1",
    "140978": "SE",
    "1409208": "SE",
    "1409126": "S1",
    "140950": "S1",
    "1409127": "S1",
    "140951": "S0",
    "140974": "S0",
    "1409128": "S1",
    "140981": "SE",
    "140952": "S1",
    "1409129": "S1",
    "1409209": "SE",
    "140953": "S1",
    "1409177": "S2",
    "1409111": "S1",
    "1409112": "S1",
    "1409113": "S1",
    "1409178": "S2",
    "1409105": "S0",
    "1409179": "S2",
    "140988": "S1",
    "1409180": "S2",
    "1409181": "S2",
    "1409130": "S1",
    "1409182": "S2",
    "1409183": "S2",
    "140957": "S2",
    "1409185": "S2",
    "1409186": "S2",
    "1409187": "S2",
    "1409188": "S2",
    "140991": "SE",
    "1409189": "S2",
    "140958": "S1",
    "140959": "S2",
    "140960": "S1",
    "1409190": "S2",
    "1409191": "S2",
    "1409192": "S2",
    "1409193": "S2",
    "1409194": "S2",
    "140993": "S2",
    "140968": "S2",
    "1409197": "S2",
    "1409196": "S2",
    "1409198": "S2",
    "140969": "S1",
    "140975": "S0",
    "140976": "S0",
    "1409199": "S2",
    "1409218": "S0",
    "1409219": "S0",
    "1409221": "S1",
    "1409220": "S1",
    "1409222": "S2",
    "1409223": "S2",
    "1409224": "SE",
    "1409225": "SE"
};

export const SPORT_GROUPS = {
  S0: {
    id: 'S0',
    code: 'S0',
    name: 'Група S0 (мінімальний ризик)',
    shortName: 'Група S0',
    description: 'Шахи, шашки, настільний теніс, боулінг, більярд тощо',
    coefficient: { amateur: 1.0, professional: 1.0 },
    ingoCodes: { amateur: '1409218', professional: '1409219' },
    categoryCodes: { amateur: '10236763', professional: '10236764' },
    sports: [
      'Авіамодельний спорт',
      'Автомодельний спорт',
      'Більярдний спорт',
      'Боулінг',
      'Го',
      'Городковий спорт',
      'Дартс',
      'Міні-гольф',
      'Петанк',
      'Радіоспорт',
      'Ракетомодельний спорт',
      'Риболовний спорт (крім риболовлі у важкодоступних та віддалених місцевостях)',
      'Спортивне орієнтування',
      'Спортивний бридж',
      'Судномодельний спорт',
      'Теніс настільний',
      'Шахи',
      'Шашки'
    ]
  },
  S1: {
    id: 'S1',
    code: 'S1',
    name: 'Група S1 (помірний ризик)',
    shortName: 'Група S1',
    description: 'Бадмінтон, баскетбол, волейбол, плавання, легка атлетика, фітнес тощо',
    coefficient: { amateur: 1.5, professional: 2.0 },
    ingoCodes: { amateur: '1409221', professional: '1409220' },
    categoryCodes: { amateur: '10236765', professional: '10236766' },
    sports: [
      'Аквабайк',
      'Акробатичний рок-н-рол',
      'Бадмінтон',
      'Баскетбол',
      'Бейсбол',
      'Бодібілдинг',
      'Вейкбординг',
      'Велосипедний спорт, крім маунтбайку',
      'Веслування академічне',
      'Веслування на байдарках та каное',
      'Веслування на човнах "Дракон"',
      'Веслувальний слалом',
      'Вітрильний спорт',
      'Водне поло',
      'Воднолижний спорт',
      'Водно-моторний спорт',
      'Волейбол',
      'Волейбол пляжний',
      'Гирьовий спорт',
      'Гольф',
      'Дзюдо',
      'Естетична гімнастика',
      'Легка атлетика',
      'Пейнтбол',
      'Перетягування канату',
      'Повітроплавальний спорт',
      'Пожежно-прикладний спорт',
      'Практична стрільба',
      'Сквош',
      'Скелелазіння',
      'Софтбол',
      'Спорт із собаками',
      'Спортивна аеробіка',
      'Спортивна акробатика',
      'Спортивний туризм (крім гірського 2000-4500м та спелеотуризму)',
      'Спортивні танці',
      'Спортінг',
      'Стрибки на батуті',
      'Стрільба з лука',
      'Стрільба кульова',
      'Стрільба стендова',
      'Сучасне п\'ятиборство',
      'Танцювальний спорт',
      'Фехтування',
      'Фітнес',
      'Черліденг'
    ]
  },
  S2: {
    id: 'S2',
    code: 'S2',
    name: 'Група S2 (підвищений ризик)',
    shortName: 'Група S2',
    description: 'Футбол, бокс, карате, хокей, лижні гонки, гірські лижі тощо',
    coefficient: { amateur: 3.0, professional: 4.0 },
    ingoCodes: { amateur: '1409222', professional: '1409223' },
    categoryCodes: { amateur: '10236767', professional: '10236768' },
    sports: [
      'Автомобільний спорт (крім дрифту, автораллі та перегонів)',
      'Американський футбол',
      'Армспорт',
      'Багатоборство тілоохоронців',
      'Біатлон',
      'Бобслей',
      'Богатирське багатоборство',
      'Бойове самбо',
      'Бокс',
      'Боротьба вільна та греко-римська',
      'Боротьба кураш',
      'Боротьба на поясах',
      'Боротьба на поясах алиш',
      'Боротьба самбо',
      'Важка атлетика',
      'Вертолітний спорт',
      'Військово-спортивні багатоборства',
      'Гандбол',
      'Гімнастика спортивна',
      'Гімнастика художня',
      'Гірськолижний спорт',
      'Годзю-рю карате',
      'Джиу-джитсу',
      'Змішані єдиноборства (MMA)',
      'Капоейра',
      'Карате',
      'Карате JKA WF',
      'Карате JKS',
      'Карате WKC',
      'Кікбоксинг WAKO',
      'Кікбоксинг WKA',
      'Кікбоксинг WPKA',
      'Кікбоксинг ВТКА',
      'Кінний спорт',
      'Кіокушин карате',
      'Кіокушинкай карате',
      'Кіокушинкайкан карате',
      'Ковзанярський спорт',
      'Козацький двобій',
      'Комбат дзю-дзюцу',
      'Косіки карате',
      'Кунгфу',
      'Лижне двоборство',
      'Лижні гонки',
      'Літаковий спорт (крім авіараллі та повітряних гонок)',
      'Морські багатоборства',
      'Мотоциклетний спорт, крім мотораллі',
      'Панкратіон',
      'Пауерліфтинг',
      'Плавання',
      'Пляжний гандбол',
      'Пляжний футбол',
      'Поліатлон',
      'Регбі',
      'Регбіліг',
      'Роликовий спорт',
      'Рукопашний бій',
      'Санний спорт',
      'Синхронне плавання',
      'Сноубординг',
      'Стрибки на лижах з трампліна',
      'Стронгмен',
      'Сумо',
      'Таеквондо (ІТФ)',
      'Таїландський бокс муей тай',
      'Теніс',
      'Традиційне карате',
      'Триатлон',
      'Тхеквондо',
      'Українська боротьба на поясах',
      'Український рукопаш "Спас"',
      'Універсальний бій',
      'Ушу',
      'Фігурне катання на ковзанах',
      'Флорбол',
      'Французький бокс сават',
      'Фристайл',
      'Фрі-файт',
      'Фунакоші шотокан карате',
      'Футбол',
      'Футзал',
      'Хокей з шайбою',
      'Хокей на траві',
      'Хортинг',
      'Шорт-трек'
    ]
  },
  SE: {
    id: 'SE',
    code: 'SE',
    name: 'Група SE (екстремальний ризик)',
    shortName: 'Група SE',
    description: 'Альпінізм, парашутний спорт, дайвінг, спелеотуризм, маунтинбайк тощо',
    coefficient: { amateur: 5.0, professional: 'Андеррайтер' },
    ingoCodes: { amateur: '1409224', professional: '1409225' },
    categoryCodes: { amateur: '10236769', professional: '10236770' },
    sports: [
      'Альпінізм',
      'Гірський туризм та трекінг на висоті від 2000 до 4500 метрів',
      'Дельтапланерний спорт',
      'Маунтинбайк',
      'Парапланерний спорт',
      'Планерний спорт',
      'Підводний спорт (в т.ч. дайвінг до 15м, фрідайвінг)',
      'Поїздки на джипах, квадроциклах, мотоциклах поза дорогами',
      'Польоти з використанням безмоторних засобів',
      'Полювання, риболовля у важкодоступних та віддалених місцях',
      'Спелеотуризм',
      'Сплав по річках (рафтинг, каякінг, катамарани)',
      'Спортивні стрибки у воду',
      'Стрибки з висоти (парашутний спорт, роупджампінг у воду)',
      'Участь у перегонах (авто-мото-авіа-раллі, дрифт, повітряні гонки)'
    ]
  }
};

export const SPORT_GROUPS_LIST = Object.values(SPORT_GROUPS);

export function getSportGroupInfo(groupKey) {
  if (!groupKey) return null;
  const upper = String(groupKey).toUpperCase();
  return SPORT_GROUPS[upper] || null;
}

export function resolveSportGroupCode(groupKey, category = 'amateur') {
  const g = getSportGroupInfo(groupKey);
  if (!g) return null;
  const catKey = category === 'professional' ? 'professional' : 'amateur';
  return g.ingoCodes[catKey];
}

export function parseSportsList(apiData) {
    const technicalCodes = ['140995', '1409218', '1409219', '1409221', '1409220', '1409222', '1409223', '1409224', '1409225'];
    return apiData
        .filter(item => !technicalCodes.includes(item.Code))
        .map(item => {
            const code = item.Code || item.Id.toString();
            return {
                name: item.Name,
                value: code,
                eId: item.EId,
                group: sportGroupMap[code] || 'S0'
            };
        })
        .sort((a, b) => a.name.localeCompare(b.name, 'uk'));
}

export const sportCategories = [
    { value: 'amateur', name: 'Аматорський' },
    { value: 'professional', name: 'Професійний' },
];

export const rawApiCategories = [
    { "IsDefault": "N", "EId": "6763", "Coefficient": 1, "Id": 114077, "Code": "10236763", "Name": "S0a(аматорський)", "group": "S0" },
    { "IsDefault": "N", "EId": "6764", "Coefficient": 1, "Id": 114078, "Code": "10236764", "Name": "S0p(професійний)", "group": "S0" },
    { "IsDefault": "N", "EId": "6765", "Coefficient": 1.5, "Id": 114086, "Code": "10236765", "Name": "S1a(аматорський)", "group": "S1" },
    { "IsDefault": "N", "EId": "6766", "Coefficient": 2, "Id": 114087, "Code": "10236766", "Name": "S1p(професійний)", "group": "S1" },
    { "IsDefault": "N", "EId": "6767", "Coefficient": 3, "Id": 114248, "Code": "10236767", "Name": "S2a(аматорський)", "group": "S2" },
    { "IsDefault": "N", "EId": "6768", "Coefficient": 4, "Id": 114249, "Code": "10236768", "Name": "S2p(професійний)", "group": "S2" },
    { "IsDefault": "N", "EId": "6769", "Coefficient": 5, "Id": 114250, "Code": "10236769", "Name": "SEa(аматорський)", "group": "SE" },
    { "IsDefault": "N", "EId": "6770", "Coefficient": 10236770, "Id": 114251, "Code": "10236770", "Name": "SEp(професійний)", "group": "SE" },
    { "IsDefault": "N", "EId": "4940", "Coefficient": 1, "Id": 114280, "Code": "10234940", "Name": "без категорії", "group": "NONE" }
];
